import { render } from "./Caption.vue?vue&type=template&id=650c9907"
import script from "./Caption.vue?vue&type=script&lang=js"
export * from "./Caption.vue?vue&type=script&lang=js"

import "./Caption.vue?vue&type=style&index=0&id=650c9907&lang=scss"
script.render = render

export default script